// extracted by mini-css-extract-plugin
export default {"cart":"Cart_cart__-PF60","priceCard":"Cart_priceCard__v+LKx"};